// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { CustomAppState } from "@sc/App/Store/Reducers";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomAppState) => ({
    // XNG-Change
    isSignInPage: getCurrentPage(state).type === "SignInPage",
});

export interface FooterStyles {
    page?: MobiusPageProps;
}

type Props = PageProps & ReturnType<typeof mapStateToProps>;

export const footerStyles: FooterStyles = {};
const styles = footerStyles;

// XNG-Change: structure
const Footer = ({ id, isSignInPage }: Props) => (
    <Page
        as="footer"
        isFooter={true}
        {...styles.page}
        css={css`
            ${styles.page?.css};
            ${isSignInPage ? "margin-top: 0;" : ""};
        `}
    >
        <Zone contentId={id} zoneName="Content" />
        <CookiePrivacyPolicyPopup />
    </Page>
);

const pageModule: PageModule = {
    component: connect(mapStateToProps)(Footer),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
